<template>
  <div class="data-view">
    <div class="left-content">
      <div style="color:rgba(170, 170, 170, 1);font-size:14px;margin-bottom:8px;">
        <a-icon type="profile" />
        项目列表选择</div>
      <ul>
        <li @click="handleSelectChange(item.id)" :class="{'active':item.id==defaultProject}" :title="item.name" :value='item.id' v-for="(item, index) in proList6" :key="index">
          {{item.name}}
        </li>
      </ul>
    </div>
    <div class="center-content">
      <div class="tag-manage" style="padding-right:24px;margin-bottom:8px;">
        <span class="title" style="font-weight:bold;">
          <a-icon style="margin-right:5px" type="calendar" />
          标签管理
        </span>
        <span @click="refreshTags" style="display:inline-block;float:right;color:rgba(34, 215, 187, 1);font-size:14px;margin-top:5px;cursor:pointer">
          <a-icon type="sync" />
          刷新
        </span>
      </div>
      <div class="card-body" style="padding:0 24px 160px">
        <div id="card-body">
          <div class="card-content">
            <div class="card" style="padding-top:25px;">
              <div @click="newScene" style="box-shadow: 0px 2px 10px 0px #ddd;width:266px;height:48px;line-height:48px;text-align:center;margin:0 auto;cursor:pointer;color:rgba(34, 215, 187, 1);font-size:16px;">
                <a-icon style="margin-right:8px;" type="plus" />
                <span class="new-card-text">按节点新建标签</span>
              </div>
              <div @click="newIntentionTag" style="box-shadow: 0px 2px 10px 0px #ddd;width:266px;height:48px;line-height:48px;text-align:center;margin:0 auto;margin-top:20px;cursor:pointer;color:rgba(34, 215, 187, 1);font-size:16px;">
                <a-icon style="margin-right:8px;" type="plus" />
                <span class="new-card-text">按意图新建标签</span>
              </div>
            </div>
          </div>
          <div class="card-content" v-for="(item, index) in proTagsList" :key="index" :class="{'spacing-15':(index==3||(index+2)%5==0)}">
            <div class="card">
              <div class="card-top">
                <div style="width:200px;float:left;">
                  <div class="card-title" :title='item.name' style="width:100%;overflow:hidden">{{item.name}}</div>
                  <div class="card-data">数据量</div>
                  <div :class="{'card-num':item.type=='INTENTION','card-proportion-num':item.type=='NODE'}">{{item.dataCount}}</div>
                </div>
                <div style="width:80px;float:left">
                  <div class="card-icon">
                    <a-icon @click="chooseItem(item,index)" style="margin-right:15px" type="edit" />
                    <a-icon type="delete" @click="confirm(item.id)" />
                  </div>
                  <div style="clear:both"></div>
                  <div class="card-proportion">占比</div>
                  <div :class="{'card-num':item.type=='INTENTION','card-proportion-num':item.type=='NODE'}">{{item.rate}}{{item.rate!=0?'%':''}}</div>
                </div>
              </div>
              <div class="card-foot" :class="{'isSelect':isSelectItem==index}" style="background:rgba(245, 246, 247, 0.5);height:35px;overflow:hidden">
                <div style="height:34px;display:inline-block;width:236px;padding-left:16px;float:left;line-height:34px;">
                  <span v-if="item.type=='INTENTION'" style="display:inline-block;width:64px;height:24px;background:rgba(255, 141, 26, 0.1);color:rgba(255, 141, 26, 1);font-size:12px;margin-top:5px;margin-right:6px;float:left;text-align:center;line-height:24px;">意图标签</span>
                  <span v-if="item.type=='NODE'" style="display:inline-block;width:64px;height:24px;background:rgba(78, 138, 250, 0.1);color:rgba(78, 138, 250, 1);font-size:12px;margin-top:5px;margin-right:6px;float:left;text-align:center;line-height:24px;">节点标签</span>
                  <div v-if="item.type=='NODE'" style="display:inline-block;float:left;">
                    <span>交互时长：</span>
                    <span>{{item.minCallDuration}}-{{item.maxCallDuration}}秒</span>
                  </div>
                  
                  <span style="width:1px;height:15px;background:rgb(221, 221, 221);display:inline-block;float:right;margin-top:10px"></span>
                </div>
                <div style="line-height:34px;width:75px;display:inline-block;text-align:center;color:rgba(153, 153, 153, 1);cursor:pointer;float:right" @click="syncTag(item.id)">
                  <span>
                    <a-icon type="reload" style="margin-right:5px"/>
                    同步
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="right-content" v-if="isShowNode">
      <div style="color:rgba(51, 51, 51, 1);font-size:16px;">{{tagAttr}}</div>
      <div class="title">标签名称：</div>
      <a-input style="border-color:rgba(238, 238, 238, 1)" placeholder='请输入标签名称' v-model ='tagName' />
      <div class="title">交互时长：</div>
      <div>
        <a-input-number style="border-color:rgba(238, 238, 238, 1)" id="inputNumber" v-model="tagInteractiveTimeMin"/>——<a-input-number style="border-color:rgba(238, 238, 238, 1)" id="inputNumber" v-model="tagInteractiveTimeMax"/>
      </div>
      <div class="title">包含节点：</div>
      <div>
        <a-select
          mode="multiple"
          :size="size"
          :defaultValue="tagIncludeNodeList"
          v-model="tagIncludeNodeList"
          style="width: 100%;border-color:rgba(238, 238, 238, 1)"
          @change="handleChangeIn"
        >
          <a-select-option :title="item.name" :value="item.id" v-for="(item, index) in nodeList" :key="index">
             {{item.name}}
          </a-select-option>
        </a-select>
      </div>
      <div class="title">不包含节点</div>
      <div>
        <a-select
          mode="multiple"
          :size="size"
          :defaultValue="tagUnIncludeNodeList"
          v-model="tagUnIncludeNodeList"
          style="width: 100%;border-color:rgba(238, 238, 238, 1)"
          @change="handleChangeOut"
        >
          <a-select-option :title="item.name" :value="item.id" v-for="(item, index) in nodeList" :key="index">
            {{item.name}}
          </a-select-option>
        </a-select>
      </div>
      <div class="btn-group" style="float:left">
        <a-button @click="cancelCarry" style="background:#fff;border-color:rgba(34, 215, 187, 1);color:rgba(34, 215, 187, 1);margin-left:0px">取消</a-button>
        <a-button id="save-btn" @click="saveData" style="background:rgba(34, 215, 187, 1);border-color:rgba(34, 215, 187, 1);color:#fff">保存</a-button>
      </div>
    </div>
    <div class="right-content2" v-if="isShowIntention">
      <div style="color:rgba(51, 51, 51, 1);font-size:16px;">{{tagAttr}}</div>
      <div class="title">标签名称：</div>
      <a-input v-model="intentionData.name" style="border-color:rgba(238, 238, 238, 1)" placeholder='请输入标签名称'/>
      <div class="title">选择节点：</div>
      <div>
        <a-select
          :defaultValue="intentionData.nodeId"
          v-model="intentionData.nodeId"
          style="width: 100%;border-color:rgba(238, 238, 238, 1)"
          @change="changeNode"
        >
          <a-select-option :title="item.name" :value="item.id" v-for="(item, index) in nodeList" :key="index">
             {{item.name}}
          </a-select-option>
        </a-select>
      </div>
      <div class="title">选择包含意图：</div>
      <div>
        <a-select
          mode="multiple"
          :size="size"
          :defaultValue="intentionData.intentionIdList"
          v-model="intentionData.intentionIdList"
          style="width: 100%;border-color:rgba(238, 238, 238, 1)"
          @change="changeIntention"
        >
          <a-select-option :title="item.name" :value="item.id" v-for="(item, index) in intentionList" :key="index">
             {{item.name}}
          </a-select-option>
        </a-select>
      </div>
      <div class="btn-group" style="float:left">
        <a-button @click="cancelIntention" style="background:#fff;border-color:rgba(34, 215, 187, 1);color:rgba(34, 215, 187, 1);margin-left:0px">取消</a-button>
        <a-button id="save-btn" @click="saveIntentionData" style="background:rgba(34, 215, 187, 1);border-color:rgba(34, 215, 187, 1);color:#fff">保存</a-button>
      </div>
    </div>
    <!-- <router-link target="_blank" rel="opener" to="/Communication" class="dialogBox">
      <a-icon style="z-index:1000;font-size:25px" type="message" />
    </router-link> -->
  </div>
</template>

<script>
export default {
  name: 'DataView',
  props: {
    msg: String
  },
  data() {
    return {
      isShowNode:false,
      isShowIntention: false,
      size: 'default',
      proList6: [],
      projectId: '',
      tagId: '',
      proTagsList: [],
      tagName: '',
      tagInteractiveTimeMin: '',
      tagInteractiveTimeMax: '',
      tagIncludeNodeList: [],
      tagUnIncludeNodeList: [],
      defaultProject: '',
      isSelectItem: null,
      nodeList: [],
      tagAttr: '',
      intentionData: {
        id: '',
        name: '',
        nodeId: '',
        intentionIdList: []
      },
      intentionList: []
    }
  },
  methods: {
    changeNode(value) {
      this.intentionData.nodeId = value
      this.queryIntentionList()
    },
    queryIntentionList() {
      this.axios(
        {
          method:'get',
          url:'/api/dropdown/intention', 
          params:{
            projectId: this.projectId,
            nodeId: this.intentionData.nodeId
          }
        }
      )
      .then(response=> {
        if(response.data.code == 0){
          this.intentionList = response.data.data
        }else{
          this.$message.error(response.data.message);
        }
      })
      .catch(error=> {
        console.log(error)
      })
    },
    changeIntention(value) {
      this.intentionData.intentionIdList = value
    },
    confirm(id) {
      this.$confirm({
        title: '提示',
        content: '确认要删除吗？',
        okText: '确认',
        cancelText: '取消',
        icon: 'warning',
        onOk: ()=> {
          this.deleteTag(id)
        },
      })
    },
    newScene(){
      if(this.projectId == ''){
        this.$message.error('请先选择项目');
      }else{
        this.isShowIntention = false
        this.isShowNode = true
        this.tagName = ''
        this.tagInteractiveTimeMin = ''
        this.tagInteractiveTimeMax = ''
        this.tagIncludeNodeList = []
        this.tagUnIncludeNodeList = []
        this.tagId = ''
        this.tagAttr = '新建标签'
        this.isSelectItem = null
      }
    },
    newIntentionTag() {
      if(this.projectId == ''){
        this.$message.error('请先选择项目');
      }else{
        this.isShowNode = false
        this.isShowIntention = true
        this.intentionData.name = ''
        this.intentionData.nodeId = ''
        this.intentionData.intentionIdList = []
        this.isSelectItem = null
        this.intentionList = []
        this.tagId = ''
      }
    },
    cancelIntention() {
      this.isShowIntention = false
      this.intentionData.name = ''
      this.intentionData.nodeId = ''
      this.intentionData.intentionIdList = []
      this.isSelectItem = null
      this.intentionList = []
    },
    saveIntentionData() {
      if(this.projectId == ''){
        this.$message.error('请先选择项目');
      }else{
        this.axios.post('/api/callLabel/intentionLabel', {
          id: this.tagId,
          projectId: this.projectId,
          name: this.intentionData.name,
          nodeId: this.intentionData.nodeId,
          intentionIdList: this.intentionData.intentionIdList,
        })
        .then(response=> {
          if(response.data.code == 0){
            this.$message.success('保存成功');
            this.isShowIntention = false
            this.intentionData.name = ''
            this.intentionData.nodeId = ''
            this.tagId = ''
            this.intentionList = []
            this.queryTagsData()
          }else{
            this.$message.error(response.data.message);
          }
        })
        .catch(error=> {
          console.log(error)
        })
      }
    },
    handleSelectChange(value){
      if(this.defaultProject != value){
        this.tagName = ''
        this.tagInteractiveTimeMin = ''
        this.tagInteractiveTimeMax = ''
        this.tagIncludeNodeList = []
        this.tagUnIncludeNodeList = []
        this.isSelectItem = null
        this.projectId = value
        this.defaultProject = value
        this.isShowIntention = false
        this.isShowNode = false
        this.intentionData.name = ''
        this.intentionData.nodeId = ''
        this.intentionData.intentionIdList = []
        this.intentionList = []
        this.queryTagsData()
        this.queryNodeList()
      }
    },
    handleChangeIn(value) {
      this.tagIncludeNodeList = value
    },
    handleChangeOut(value) {
      this.tagUnIncludeNodeList = value
    },
    queryTagsData() {
      if(this.projectId == ''){
        this.$message.error('请先选择项目');
      }else{
        this.axios(
          {
            method:'get',
            url:'/api/callLabel/list', 
            params:{
              projectId: this.projectId
            }
          }
        )
        .then(response=> {
          if(response.data.code == 0){
            this.proTagsList = response.data.data
          }else{
            this.$message.error(response.data.message);
          }
        })
        .catch(error=> {
          console.log(error)
        })
      }
    },
    deleteTag(value) {
      this.axios.post('/api/callLabel/delete', {
        id: value,
      })
      .then(response=> {
        if(response.data.code == 0){
          this.$message.success('删除成功');
          this.queryTagsData()
        }else{
          this.$message.error(response.data.message);
        }
      })
      .catch(error=> {
        console.log(error)
      })
    },
    syncTag(value) {
      this.axios.post('/api/callLabel/refresh', {
        id: value,
      })
      .then(response=> {
        if(response.data.code == 0){
          this.$message.info('后台计算中...');
        }else{
          this.$message.error(response.data.message);
        }
      })
      .catch(error=> {
        console.log(error)
      })
    },
    cancelCarry() {
      this.tagName = ''
      this.tagInteractiveTimeMin = ''
      this.tagInteractiveTimeMax = ''
      this.tagIncludeNodeList = []
      this.tagUnIncludeNodeList = []
      this.tagId = ''
      this.isShowNode = false
      this.isSelectItem = null
    },
    saveData() {
      if(this.projectId == ''){
        this.$message.error('请先选择项目');
      }else{
        this.axios.post('/api/callLabel/nodeLabel', {
          id: this.tagId,
          projectId: this.projectId,
          name: this.tagName,
          minCallDuration: this.tagInteractiveTimeMin,
          maxCallDuration:this.tagInteractiveTimeMax,
          includeNodeList:this.tagIncludeNodeList,
          excludeNodeList:this.tagUnIncludeNodeList
        })
        .then(response=> {
          if(response.data.code == 0){
            this.$message.success('保存成功');
            this.queryTagsData()
            this.tagName = ''
            this.tagInteractiveTimeMin = ''
            this.tagInteractiveTimeMax = ''
            this.tagIncludeNodeList = []
            this.tagUnIncludeNodeList = []
            this.tagId = ''
            this.isShowNode = false
          }else{
            this.$message.error(response.data.message);
          }
        })
        .catch(error=> {
          console.log(error)
        })
      }
    },
    chooseItem(item, index) {
      this.isSelectItem = index
      if(item.type == 'NODE'){
        this.tagAttr = '编辑节点标签'
        this.tagId = item.id
        this.isShowIntention = false
        this.isShowNode = true
        this.viewNodeDetail(item.id)
      }else{
        this.tagAttr = '编辑意图标签'
        this.isShowNode = false
        this.tagId = item.id
        this.isShowIntention = true
        this.intentionData.id = item.id
        this.viewIntentionDetail(item.id)
      }
    },
    queryNodeList() {
      this.axios(
        {
          method:'get',
          url:'/api/dropdown/node', 
          params: {
            projectId: this.projectId,
          }
        }
      )
      .then(response=> {
        if(response.data.code == 0){
         this.nodeList = response.data.data
        }else{
          this.$message.error(response.data.message);
        }
      })
      .catch(error=> {
        console.log(error)
      })
    },
    viewNodeDetail(id){
      this.axios(
        {
          method:'get',
          url:'/api/callLabel/nodeLabel', 
          params: {
            id: id,
          }
        }
      )
      .then(response=> {
        if(response.data.code == 0){
          this.tagName = response.data.data.name
          this.tagInteractiveTimeMin = response.data.data.minCallDuration
          this.tagInteractiveTimeMax = response.data.data.maxCallDuration
          this.tagIncludeNodeList = response.data.data.includeNodeList
          this.tagUnIncludeNodeList = response.data.data.excludeNodeList 
        }else{
          this.$message.error(response.data.message);
        }
      })
      .catch(error=> {
        console.log(error)
      })
    },
    viewIntentionDetail(id){
      this.axios(
        {
          method:'get',
          url:'/api/callLabel/intentionLabel', 
          params: {
            id: id,
          }
        }
      )
      .then(response=> {
        if(response.data.code == 0){
          this.intentionData.name = response.data.data.name
          this.intentionData.nodeId = response.data.data.nodeId
          this.intentionData.intentionIdList = response.data.data.intentionIdList
          this.queryIntentionList()
        }else{
          this.$message.error(response.data.message);
        }
      })
      .catch(error=> {
        console.log(error)
      })
    },
    refreshTags() {
      this.queryTagsData()
    }
  },
  mounted: function() {
    this.sessionData('set','currentNavItem','DataView');
    if(this.$route.query.projectId != undefined){
      this.axios.get('/api/dropdown/project')
      .then(response=> {
        if(response.data.code == 0){
          this.proList6 = response.data.data
          if(this.proList6.length > 0){
            this.projectId = this.$route.query.projectId
            this.defaultProject = this.$route.query.projectId
            this.queryTagsData()
            this.queryNodeList()
          }
        }else{
          this.$message.error(response.data.message);
        }
      })
      .catch(error=> {
        console.log(error)
      })
    }else{
      this.axios.get('/api/dropdown/project')
      .then(response=> {
        if(response.data.code == 0){
          this.proList6 = response.data.data
          if(this.proList6.length > 0){
            this.projectId = this.proList6[0]['id']
            this.defaultProject = this.proList6[0]['id']
            this.queryTagsData()
            this.queryNodeList()
          }
        }else{
          this.$message.error(response.data.message);
        }
      })
      .catch(error=> {
        console.log(error)
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
  ::-webkit-scrollbar {
    display: none; /* Chrome Safari */
  }
  .data-view{
    background: rgba(240, 242, 243, 1);
    height: 100%;
    display: flex;
    .left-content{
      width: 240px;
      background: #fff;
      height: 100%;
      padding:24px 0;
      overflow-y: auto;
      padding-bottom: 50px;
      div{
        padding-left:24px;
      }
      ul{
        li{
          height: 48px;
          line-height: 48px;
          color:rgba(80, 80, 80, 1);
          padding-left:24px;
          padding-right:24px;
          cursor: pointer;
          width: 100%;
          overflow: hidden;
          font-size: 14px;
        }
        li.active{
          background: rgba(34, 215, 187, 0.1);
          color: rgba(34, 215, 187, 1);
          border-right: 2px solid rgba(34, 215, 187, 1);
        }
        li:hover{
           background: rgba(34, 215, 187, 0.1);
        }
      }
    }
    .center-content{
      height: 100%;
      flex: 1;
      .tag-manage{
        height: 53px;
        background: #fff;
        padding: 15px 0 0 24px;
        span{
          float: left;
          color: rgba(51, 51, 51, 1);
          font-size: 18px;
        }
        button{
          float: right;
          background: rgba(34, 215, 187, 1);
          border-color: rgba(34, 215, 187, 1);
        }
      }
      .card-body{
        width: 100%;
        overflow: auto;
        height: 100%;
        padding-bottom: 84px;
        #card-body{
          float: left;
          .card-content{
            display:inline-block;
            width: 311px;
            height:168px;
            float: left;
            margin-top:16px;
            overflow: hidden;
            margin-right: 15px;
            .card-foot{
              color: rgba(204, 204, 204, 1);
              font-size: 12px;
            }
            .isSelect{
              background: #00BAAD !important;
              color: #fff !important;
              span{
                color: #fff !important;
              }
              
            }
          }
        }
      }
      
      .pro-content-text{
        font-size: 18px;
        font-weight: 600;
        border-bottom: 1px solid #ccc;
        height: 45px;
        line-height: 35px;
        margin-bottom: 24px;
      }
      .delete{
        position: absolute;
        right: 0px;
        top: 10px;
        cursor: pointer;
      }
      .card{
        width: 100%;
        cursor: default;
        height:168px;
        // margin-top: 24px;
        border-radius: 4px;
        position: relative;
        overflow: hidden;
        background: #fff;
        .new-card{
          display: inline-block;
          font-size: 30px;
          font-weight: bold;
          text-align: center;
          // line-height: 25px;
        }
        .new-card-text{
          font-size: 18px;
          margin-top: 10px;
        }
        .card-top:hover{
          .card-icon{
              i{
              cursor: pointer;
              display: inline-block;
              
            }
          }
        }
        .card-top{
          height: 134px;
          padding: 24px 0px 0 25px;
          .card-title{
            height: 26px;
            margin-bottom:14px;
            font-size: 16px;
            color: rgba(51, 51, 51, 1);
          }
          .card-data{
            height: 20px;
            font-size: 14px;
            color: rgba(153, 153, 153, 1);
          }
          .card-num{
            // height: 30px;
            font-size: 24px;
            color: rgba(255, 141, 26, 1);
            // font-weight: bold;
          }
          .card-icon{
            height: 40px;
            font-size: 18px;
            color: rgba(34, 215, 187, 1);
            font-weight: bold;
            float: right;
            margin-right: 24px;
            i{
              cursor: pointer;
              display: none;
              
            }
          }
          .card-proportion{
            height: 20px;
            font-size: 14px;
            color: rgba(153, 153, 153, 1);
          }
          .card-proportion-num{
            // height: 30px;
            font-size: 24px;
            color: rgba(78, 138, 250, 1);
            // font-weight: bold;
          }
        }
      }
      .add-card{
        text-align: center;
        padding-top:40px;
      }
    }
    .right-content{
      width: 316px;
      height: 100%;
      background: #fff;
      padding: 24px;
      .title{
        color: rgba(80, 80, 80, 1);
        font-size: 14px;
        margin: 24px 0 10px 0;
      }
      .btn-group{
        margin-top: 24px;
        button{
          margin-left: 20px;
        }
      }
    }
    .right-content2{
      width: 316px;
      height: 100%;
      background: #fff;
      padding: 24px;
      .title{
        color: rgba(80, 80, 80, 1);
        font-size: 14px;
        margin: 24px 0 10px 0;
      }
      .btn-group{
        margin-top: 24px;
        button{
          margin-left: 20px;
        }
      }
    }
  }
  #save-btn{
    color: #fff !important;
  }
</style>
